import { ApiError, fieldErrorsOf } from '../api/client';

export interface ServerErrors {
  fields: Record<string, string>;
  /** Form-level message when the API rejected the request without naming a field. */
  form?: string;
  /** Toast title for failures that are not the user's input (5xx, network). */
  toast?: { title: string; description?: string };
}

function conflictErrors(err: ApiError, slugField: string): ServerErrors {
  if (err.code.includes('IDEMPOTENCY')) return { fields: {}, form: 'This request was already sent with different values — reload and try again.' };
  const fields = fieldErrorsOf(err);
  return { fields: Object.keys(fields).length > 0 ? fields : { [slugField]: 'slug already exists' } };
}

function invalidInputErrors(err: ApiError): ServerErrors {
  const fields = fieldErrorsOf(err);
  return Object.keys(fields).length > 0 ? { fields } : { fields: {}, form: err.message };
}

function toastErrors(err: ApiError): ServerErrors {
  return { fields: {}, toast: { title: err.toastTitle, description: err.status === 0 ? err.message : `${err.code} · ${err.message}` } };
}

/** Maps an API failure to what a form shows: 409 → under the slug, 422 → per field, everything else → toast. */
export function serverErrorsOf(err: unknown, slugField = 'slug'): ServerErrors {
  if (!(err instanceof ApiError)) {
    return { fields: {}, toast: { title: 'Something went wrong', description: err instanceof Error ? err.message : undefined } };
  }
  if (err.status === 409) return conflictErrors(err, slugField);
  if (err.status === 422 || err.status === 400) return invalidInputErrors(err);
  if (err.status === 403) return { fields: {}, form: `You are not allowed to do this (${err.code}).` };
  return toastErrors(err);
}
